import axios from "axios";

class UploadService {
    upload(file, owner, uploader) {
        return new Promise((resolve, reject) => {
            if (!file) return resolve([]);

            const url = process.env.VUE_APP_UPLOAD_URL;
            const formData = new FormData();
            formData.append("file", file);
            if (owner) {
                formData.append('owner', owner);
            }
            if (uploader) {
                formData.append('uploader', uploader);
            }
            axios.post(url, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
                .then(res => {
                    resolve(res.data);
                })
                .catch(reject);
        });
    }
}

export default UploadService;